<template>

    <div class="big-page" ><!-- :style="{'background-image':`url(${backgroundSrc})`}" -->
        
        
        <div class="big-page-container">
            <div class="cnt_text">
                <div class="go-back">
                    <router-link to="/orologio/"> ← Torna all'orologio </router-link>
                </div>
                <div class="text" ref="text"> 
                        <!-- <div class="link">
                            <div class="left_arrow">&#8592; ciao</div>
                            <div class="right_arrow">caio &#8594;</div>
                        </div> -->
                        <!-- Parte del titolo -->
                        <div class="cnt_titolo" >
                            <p  class="titolo" ref="titolo">{{titolo}}</p>
                        </div>  
                        <div class="underline_text"></div>
                        <div class="cnt_animation" ref="cnt_text_animation">
                            <div>
                                <slot name="testo"></slot>
                            </div>
                        </div>
                        <div class="downloads" ref="downloads">
                                <div class="download-text">
                                <a :class="{}" class="download" :href="download" ref="download" v-for="(download) in downloads" :key="download">{{download}}</a>
                                </div>             
                        </div>
                </div>
                <!-- Parte del contenuto -->
            </div>

            <div class="media" ref="media" > 
                <div>
                    <slot name="media"></slot>
                </div>
            </div>
        </div>
    </div>

</template>


<script>

import  {TimelineMax, TweenMax, Power4} from "gsap";

export default {
    name: 'big-page',
    props: {
        downloads: {
            type: Array
        },
        titolo: {
            type: String,
            required: true
        },
        backgroundSrc: {
            type: String
        }
    },
    data() {
        return {
            prova: []
        }
    },
    methods:{
        onNavigateTo() {
            let tl=new TimelineMax({});


            tl.set(this.$refs.cnt_text_animation, { opacity:"0" });
            tl.set(this.$refs.titolo, { bottom: "-7em", opacity:"1" });
            tl.to(this.$refs.titolo, {duration:2.0, opacity:"1", bottom: "0",ease:"Power4.easeOut"});
            tl.to(this.$refs.cnt_text_animation,{duration:.5,opacity:"1"},"-=.7");

            
           

            
            tl.to(this.$refs.media, 1.2, {duration:1.2, opacity:"1", x: "0",ease:Power4.easeOut},"-=1");
            let downloads = this.$refs.download.reverse();
            if(downloads) {
                console.log( this.$refs.download.reverse()[downloads.length-1]);
                tl.to(downloads[downloads.length-1], 1.2, {duration:1.2, opacity:"1", x: "0",ease:Power4.easeOut}, "-=1");

                for(let c = downloads.length-2; c >= 0; c-- ) {
                    tl.to(downloads[c], .5, {duration:.5, opacity:"1", x: "0",ease:Power4.easeOut}, "-=.7" );
                }
            }
        }
    }

}
</script>

<style scoped> 
.go-back {
    margin: 25px 0px 0px 25px;
}
.go-back a {
    color: var(--primary-color) ;
    font-weight: lighter;
    text-decoration: none;
}

.go-back a:hover {
    text-decoration:  underline;
    /* color: var(--secondary-color); */
}

.big-page {
    width: 100%;
    height: 100vh;
    position: relative;
    color: var(--primary-color);
    background-color: var(--background-color);
}
.cnt_titolo{  
    position: relative;  
    height: 10vh;
    width: auto;
    overflow: hidden;
}
.titolo{
    font-size: 42px;
    color: var(--primary-color);
    margin-bottom: 25px;
    position: absolute;
    line-height: 50px;
    bottom: -7em;
    font-weight: bold;
    text-transform: capitalize;
}

.title {
    /* background-color: blue; */
    grid-area: tit;
    font-size: 4.2em;
    font-weight: bold;
    display:flex;
    align-items: center;
    width: 35%;
    height: 20%;
}

.title > div {
    overflow: hidden;
    position: relative;
    height: 1.5em;
    width: 100%;

}

.title  span {
    position: absolute;
    bottom: 0;
    color: var(--primary-color);
}

.text {
    /* background-color: red; */
    /* grid-area: tex; */
    /* padding: 20px; */
    line-height: 2em;
    font-size: 1.0em;
    margin: 25px  10% 5% 10%;
    color: #D0D0D0;
    /* display: flex;
    align-items: center;
    justify-content: center; */ 
} 

.cnt_text {
    
    /* overflow: auto; */ 
    height: 100vh;

}
.text {
    

}
 
.downloads {
    /* background-color: yvellow; */
    grid-area: dow;
    justify-content: center;
    align-items: center;
    display: flex;
    position: relative;
    height: 10vh;
    margin-bottom: 5%;
}

.media {
    /* background-color: green; */
/*     grid-area: med;*/ 
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh; 
    /* background-image: url("https://www.motherjones.com/wp-content/uploads/spycamp-menner-2000px.jpg"); */
    background-position: center right;
    background-size: cover;

}

.media > div {
    overflow: auto;
    height: 100%;
    width: 100%;
    position: relative;
}

.download-text {
    position: absolute;
    top: 0px; 
    /* font-size: 1.1em;
    font-weight: bold; */
}

.big-page-container {
    background-color: rgba(0, 0, 0, 0.8);
    left: 0;
    position: absolute;
    width: 100%;
    height: 100%;
    display: grid;
    /* grid-gap: 15px; */
    grid-template-rows: 10em 1fr 1fr 15vh;
    grid-template-columns: 50% 50%;
    grid-template-areas:
    "tit tit"
    "tex med"
    "tex med"
    "dow med" ;
}

.download {
    padding:10px 35px 10px 35px; 
    color: var(--background-color);
    border-radius: 15px;
    background-color: var(--primary-color);
    text-decoration: none;
    margin: 15px;
    color: var(--secondary-color);
    transition: .8s;
    margin-top: 10%;
    height: 10vh;
}

.download:hover{ 
    color: var(--background-color);
    border-radius: 15px;
    background-color: var(--secondary-color);
    text-decoration: none;
    margin: 15px;
    color: var(--primary-color);
    transition: 0.4s;
}


.underline_text{
    background-color: var(--secondary-color);
    height: 10px;
    width: 50%;
    margin-bottom: 10%;
}

.link{
    display: inline-block;
    width: 44vw;
    height: auto;
}

.right_arrow{
    float: right;
    
}
.left_arrow{
    float: left;
}

.cnt_animation{
    position: relative;
    overflow: auto;
    opacity: 0;
    height: auto;
    width: auto;
    max-height:67.5vh;
    margin-bottom: 15%;
    transform: scaleX(-1);
    margin-left: -5vw; 
}
.cnt_animation div {
    transform: scaleX(-1);
    margin: 0vw 5vw 0vw 0vw;
}

</style>